export enum ReportType {
  DEFAULT = 'DEFAULT',
  NON_BILLABLE = 'NON_BILLABLE',
  ABUSE = 'ABUSE',
  BUG_REPORT = 'BUG_REPORT',
  END = 'END',
}
